module.exports = __webpack_public_path__ + "img/icon_square_pen.f571596b.svg";